import { FrameHistory } from '../models/manager-content-vehicle-history-drawer.model';

export interface PopupFrame {
  latitude: number;
  longitude: number;
  altitude?: number;
  speed?: number;
  direction?: number;
  date?: Date;
}

let popupIdCounter = 0;

export const createPopupFrame = (
  coords: PopupFrame,
  tramaIndex: number = 1,
  color: string
) => {
  popupIdCounter++;
  const id = `popup-${popupIdCounter}`;
  const urlGoogleMaps = `https://www.google.com/maps/search/?api=1&query=${coords.latitude},${coords.longitude}`;
  const longitude = coords.longitude ? `${coords.longitude.toFixed(6)}°` : '0°';
  const latitude = coords.latitude ? `${coords.latitude.toFixed(6)}°` : '0°';
  const altitude = coords.altitude ? `${coords.altitude} m` : '0 m';
  const direction = coords.direction ? `${coords.direction}°` : '0°';
  const speed = coords.speed ? `${coords.speed} km/h` : '0 km/h';
  const date = coords.date
    ? new Date(coords.date).toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      }).replace(',', '')
    : '00/00/0000 00:00:00';

  // IDs únicos para cada botón
  const ids = {
    pos: `${id}-pos`,
    alt: `${id}-alt`,
    dir: `${id}-dir`,
    speed: `${id}-speed`,
    date: `${id}-date`,
  };

  // Formatear el número de trama con ceros a la izquierda (5 dígitos)
  const tramaNumber = tramaIndex.toString().padStart(5, '0');

  // Header tipo chip
  const header = `
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px;">
      <div style="flex:1; display:flex; justify-content:center;">
        <span style="background:${color}88; color:#000000; font-weight:600; border-radius:12px; padding:4px 18px; font-size:13px; letter-spacing:1px; box-shadow:0 1px 4px #0001;">TRAMA ${tramaNumber}</span>
      </div>
    </div>
  `;

  const popup = `
    ${header}
    <div id="${id}" style="font-family: 'Inter', Arial, sans-serif; font-size: 13px; color: #222;">
      <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
        <span style="font-weight: 600; min-width: 80px;">Posición:</span>
        <span id="${
          ids.pos
        }-content" style="min-width: 170px; color: #1976d2; text-decoration: underline; cursor: pointer;" onclick="window.open('${urlGoogleMaps}', '_blank')">${latitude}, ${longitude}</span>
        <span id="${
          ids.pos
        }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
      </div>
      ${
        altitude
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; min-width: 80px;">Altitud:</span>
          <span style="min-width: 170px;" id="${ids.alt}-content">${altitude}</span>
          <span id="${ids.alt}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        direction
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; min-width: 80px;">Dirección:</span>
          <div style="display: flex; align-items: center; gap: 8px; min-width: 170px;">
            <svg width="20" height="20" viewBox="0 0 24 24" style="transform: rotate(${
              coords.direction || 0
            }deg); transition: transform 0.3s ease;">
              <path fill="#1976d2" d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span id="${ids.dir}-content">${direction}</span>
          </div>
          <span id="${
            ids.dir
          }" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        speed
          ? `
        <div style="margin-bottom: 4px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; min-width: 80px;">Velocidad:</span>
          <span style="min-width: 170px;" id="${ids.speed}-content">${speed}</span>
          <span id="${ids.speed}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
      ${
        date
          ? `
        <div style="margin-bottom: 12px; display: flex; align-items: center; gap: 4px;">
          <span style="font-weight: 600; min-width: 80px;">Fecha:</span>
          <span style="min-width: 170px;" id="${ids.date}-content">${date}</span>
          <span id="${ids.date}" style="cursor:pointer;" title="Copiar"><svg width="16px" height="16px" fill="#999"><use xlink:href="/assets/icons/sprite.svg#copy"></use></svg></span>
        </div>
      `
          : ''
      }
    </div>
  `;

  // Devuelve el HTML y los valores a copiar para el listener externo
  return {
    html: popup,
    ids,
    values: {
      pos: `${coords.latitude},${coords.longitude}`,
      alt: coords.altitude?.toString() ?? '',
      dir: coords.direction?.toString() ?? '',
      speed: coords.speed?.toString() ?? '',
      date: date ?? '',
    },
  };
};

export function adaptFrameHistoryToPopupFrame(frame: FrameHistory): PopupFrame {
  return {
    latitude: parseFloat(frame.lat),
    longitude: parseFloat(frame.lng),
    altitude: frame.altitude,
    direction: frame.angle,
    speed: frame.speed,
    date: new Date(frame.dt_tracker),
  };
}
